import Uppy from 'uppy/dist/uppy.min';
import 'uppy/dist/uppy.min.css';
import BootstrapNavTabs from '../../entrypoints/src/admin/components/bootstrap_nav_bars';
import { Controller } from "stimulus";
import { isEmpty } from 'lodash';

export default class extends Controller {
  static targets = ["fiscalLabel"];

  // Relabel the company tax id field to match the selected operating country
  // (e.g. CNPJ for Brazil, RUC for Paraguay). The country -> label map is built
  // server-side from the operating_country enum + i18n, so new countries need no JS change.
  updateFiscalLabel(event) {
    if (!this.hasFiscalLabelTarget) return;

    const labels = JSON.parse(event.target.dataset.fiscalLabels || '{}');
    const label = labels[event.target.value];

    if (label) this.fiscalLabelTarget.textContent = label;
  }

  connect() {
    BootstrapNavTabs.mergeCustomFeatures(this.element.querySelector('.tr-nav'));
    document.querySelectorAll('.upload-file').forEach((fileInput) => {
      this.fileUpload(fileInput)
    });
    this.element.querySelector('a.add-row').addEventListener('add-row:appended', (event) => {
      const row = event.detail.row,
        selectService = row.querySelector('.select-service');
      selectService.addEventListener('change', (e) => {
        const selectedData = selectService.selectedOptions[0].dataset,
          inputUnitPrice = row.querySelectorAll('input[name*="unit_price"]')[0],
          minQuantity = row.querySelectorAll('input[name*="min_quantity"]')[0],
          minValue = row.querySelectorAll('input[name*="min_value"]')[0];

        if (isEmpty(inputUnitPrice.value)) {
          inputUnitPrice.value = selectedData.unitPrice || '0.0';
        }

        if (isEmpty(minQuantity.value)) {
          minQuantity.value = selectedData.minQuantity || '0';
        }

        if (isEmpty(minValue.value)) {
          minValue.value = selectedData.minValue || '0.0';
        }
      });
    });
  }

  fileUpload(fileInput) {
    var previewContainer = document.getElementById(fileInput.getAttribute('data-preview-element'))
    fileInput.style.display = 'none' // uppy will add its own file input

    var uppy = Uppy.Core({
        id: fileInput.id,
        autoProceed: true,
      })
      .use(Uppy.FileInput, {
        target: fileInput.parentNode,
        locale: {
          strings: {
            chooseFiles: 'Selecione uma imagem'
          }
        }
      })
      .use(Uppy.Informer, {
        target: fileInput.parentNode,
      })
      .use(Uppy.ProgressBar, {
        target: previewContainer,
      })

    if (fileInput.dataset.uploadServer == 's3') {
      uppy.use(Uppy.AwsS3, {
        serverUrl: '/admin', // will call Shrine's presign endpoint mounted on `/s3/params`
      })
    } else {
      uppy.use(Uppy.XHRUpload, {
        endpoint: '/admin/upload', // Shrine's upload endpoint
        fieldName: 'file',
      })
    }

    uppy.on('upload-success', function (file, response) {
      // show image preview
      var imagePreview = document.createElement('img');
      imagePreview.classList.add('upload-preview', 'pload-preview', 'img-thumbnail', 'file-upload-preview');
      imagePreview.src = URL.createObjectURL(file.data)
      $(previewContainer).html(imagePreview);

      let fileName = (document.getElementById('company-subdomain').value || document.location.hostname.split('.')[0]) + '-cover'

      if (fileInput.dataset.uploadServer == 's3') {
        // construct uploaded file data in the format that Shrine expects
        var uploadedFileData = JSON.stringify({
          id: file.meta['key'].match(/^cache\/(.+)/)[1], // object key without prefix
          storage: 'cache',
          metadata: {
            size:      file.size,
            filename:  fileName,
            mime_type: file.type,
          }
        })
      } else {
        var uploadedFileData = JSON.stringify(response.body)
      }

      // set hidden field value to the uploaded file data so that it's submitted with the form as the attachment
      var hiddenInput = document.getElementById(fileInput.getAttribute('data-upload-result-element'))
      hiddenInput.value = uploadedFileData
    })

    return uppy
  }
}